const KEY = "athletain.auth.v1";

export const getToken = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw).token || null : null;
  } catch {
    return null;
  }
};

export const setToken = (token, expiresAt) => {
  localStorage.setItem(KEY, JSON.stringify({ token, expiresAt }));
};

export const clearToken = () => {
  localStorage.removeItem(KEY);
};

export const TOKEN_STORAGE_KEY = KEY;
